import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export default new Vuetify({});
